module.exports = __webpack_public_path__ + "img/sqzj.30afa71.png";